import apiClient from './apiClient';
import type { FC110 } from './scApi';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface FC101Detail {
  fc101_01: string;        // 報價單號
  fc101_02: number;        // 項次
  fc101_11: string;        // 產品代號第一段
  fc101_12: string;        // 產品代號第二段
  fc101_13: number;        // 預估成本
  fc101_14: number;        // 費用率%
  fc101_15: number;        // 毛利率%
  fc101_16: number;        // 售價
  fc101_17: number;        // 數量
  fc101_18: string;        // 單位
  fc101_19: number;        // 金額
  fc101_21: string;        // 付款條件
  fc101_211: string;       // 付款條件說明
  fc101_22: string;        // 交易條件
  fc101_221: string;       // 交易條件說明
  fc101_23: string;        // 交期說明
  fc101_231: string;       // 交期說明描述
  fc101_24: string;        // 產品規格
}

export interface FC100 {
  fc100_01: string;        // 報價單號 (PK)
  fc100_11: string | null; // 報價日期
  fc100_12: string;        // 客戶代號
  fc100_13: string;        // 業務代號
  fc100_14: string | null; // 報價有效日期
  fc100_15: string;        // 幣別
  fc100_16: number;        // 匯率
  fc100_17: number;        // 總金額
  fc100_18: string;        // 客戶地址
  fc100_19: string;        // YOUR REF.
  fc100_20: number;        // 總項數
  fc100_22: string;        // 備註說明
  fc100_23: string;        // 備註代號
  fc100_24: string;        // 部門代號
  fc100_25: string | null; // 建立日期
  fc100_91: string;        // 建立人員
  fc100_92: string | null; // 修改日期
  fc100_93: string;        // 修改人員
  details: FC101Detail[];  // 產品明細
}

export interface DetailRequest {
  fc101_11: string;
  fc101_12: string;
  fc101_13: number;
  fc101_14: number;
  fc101_15: number;
  fc101_16: number;
  fc101_17: number;
  fc101_18: string;
  fc101_19: number;
  fc101_21: string;
  fc101_211: string;
  fc101_22: string;
  fc101_221: string;
  fc101_23: string;
  fc101_231: string;
  fc101_24: string;
}

export interface CreateRequest {
  fc100_11: string;
  fc100_12: string;
  fc100_13: string;
  fc100_14: string;
  fc100_15: string;
  fc100_16: number;
  fc100_18: string;
  fc100_19: string;
  fc100_22: string;
  fc100_23: string;
  fc100_24: string;
  details: DetailRequest[];
}

export interface UpdateRequest {
  fc100_11: string;
  fc100_12: string;
  fc100_13: string;
  fc100_14: string;
  fc100_15: string;
  fc100_16: number;
  fc100_18: string;
  fc100_19: string;
  fc100_22: string;
  fc100_23: string;
  fc100_24: string;
  details: DetailRequest[];
}

export interface ListResponse {
  data: FC100[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const pwc201f1Api = {
  async list(page = 1, size = 20, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/pwc201f1', { params });
    return res.data;
  },

  async get(id: string): Promise<FC100> {
    const res = await apiClient.get(`/api/pwc201f1/${encodeURIComponent(id)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<FC100> {
    const res = await apiClient.post('/api/pwc201f1', data);
    return res.data;
  },

  async update(id: string, data: UpdateRequest): Promise<FC100> {
    const res = await apiClient.put(`/api/pwc201f1/${encodeURIComponent(id)}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/api/pwc201f1/${encodeURIComponent(id)}`);
  },

  /** BR-F08: Convert quotation to SC (Sales Contract) preview. Does not save. */
  async convertToSC(quotationNo: string): Promise<FC110> {
    const res = await apiClient.post('/api/sc/from-quotation', { quotationNo });
    return res.data;
  },
};
